import { makeAutoObservable } from 'mobx'
import { isLink } from 'shared/lib'
import { type INormalizedApiError } from 'shared/api'
import { type IResponseRcs } from 'entities/Rcs'

export class BrandTermsStore {
  private _privacyPolicyUrl = ''
  private _privacyPolicyError = ''
  private _termsAndConditionsUrl = ''
  private _termsAndConditionsError = ''

  constructor() {
    makeAutoObservable(this)
  }

  get privacyPolicyUrl() {
    return this._privacyPolicyUrl
  }

  get privacyPolicyError() {
    return this._privacyPolicyError
  }

  get termsAndConditionsUrl() {
    return this._termsAndConditionsUrl
  }

  get termsAndConditionsError() {
    return this._termsAndConditionsError
  }

  setPrivacyPolicyUrl = (url: string) => {
    this._privacyPolicyUrl = url
    if (this._privacyPolicyError) this._privacyPolicyError = ''
  }

  setTermsAndConditionsUrl = (url: string) => {
    this._termsAndConditionsUrl = url
    if (this._termsAndConditionsError) this._termsAndConditionsError = ''
  }

  validate = () => {
    let hasError = false

    if (!this._privacyPolicyUrl || !isLink(this._privacyPolicyUrl)) {
      this._privacyPolicyError = 'Enter a valid URL'
      hasError = true
    }

    if (!this._termsAndConditionsUrl || !isLink(this._termsAndConditionsUrl)) {
      this._termsAndConditionsError = 'Enter a valid URL'
      hasError = true
    }

    return hasError
  }

  init = (data: IResponseRcs) => {
    this._privacyPolicyUrl = data.privacy_policy_url || ''
    this._termsAndConditionsUrl = data.terms_url || ''
  }

  initErrors = (errors: INormalizedApiError) => {
    this._privacyPolicyError = errors.getError('privacy_policy_url')
    this._termsAndConditionsError = errors.getError('terms_url')
  }

  reset = () => {
    this._privacyPolicyUrl = ''
    this._privacyPolicyError = ''
    this._termsAndConditionsUrl = ''
    this._termsAndConditionsError = ''
  }
}
